<template>
  <div class="h-full">
    <Swiper :modules="modules" :pagination="true" :slides-per-view="1" class="h-full">
      <SwiperSlide>
        <img class="guide-img mt-4" src="@/assets/guides/property/welcome.webp" />
        <p class="guide-text mt-4">
          The <span class="font-bold">Property Page</span> gives you
          <span class="font-bold">critical insights</span> about a property's
          <span class="font-bold">installation</span> at a glance. It is also your starting point when reviewing all the
          installed <span class="font-bold">Network</span> and <span class="font-bold">Unit equipment</span> on the
          property.
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-4" src="@/assets/guides/property/contact-info-1.webp" />
        <p class="guide-text">
          Give more <span class="font-bold">context</span> to a <span class="font-bold">property installation</span> by
          uploading property <span class="font-bold">comments</span>, adding <span class="font-bold">photos</span>, and
          uploading
          <span class="font-bold">documents.</span>
        </p>
        <img class="guide-img" src="@/assets/guides/property/contact-info-2.webp" />
        <p class="guide-text">
          Get a high level glimpse at the <span class="font-bold">connection health</span> of the installed Gateway. Tap
          "<span class="font-bold">View Details</span>" to navigate to the Gateway Detail Page.
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <p class="guide-text mt-4">
          Helpful charts <span class="font-bold">summarize</span> the property's equipment
          <span class="font-bold">connection health</span>. Charts are visible for
          <span class="font-bold">Network</span> equipment, <span class="font-bold">Meter</span> equipment, and
          <span class="font-bold">Leak Monitoring</span> equipment.
        </p>
        <img class="guide-img mt-2" src="@/assets/guides/property/charts.webp" />
        <p class="guide-text">
          Look for the "<span class="font-bold">View Repeaters</span>" and "<span class="font-bold">View Units</span>"
          buttons to navigate to the <span class="font-bold">Network List</span> and the
          <span class="font-bold">Unit List.</span>
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-4" src="@/assets/guides/property/quick-actions.webp" />
        <p class="guide-text mt-2">
          <span class="font-bold">Quick Actions</span> can be found at the bottom of the Property Page. These links
          provide <span class="font-bold">shortcuts</span> to some of the most common property actions.
        </p>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';

const modules = [Pagination];
</script>

<style scoped>
.guide-img {
  @apply w-full max-w-[300px] md:max-w-[350px] mx-auto;
}
.guide-text {
  @apply w-[300px] max-w-[75%] mx-auto text-center text-gray-700 font-normal text-sm md:text-base;
}
</style>
